import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateWorldParams } from 'store/actions';
import { getMapSlug } from 'utils';
import { ROUTE_MAP, SCENE_IDS } from 'consts/url';
import {
  OVERVIEW_SCENE_ID,
  OVERVIEW_GROUP_ID,
} from 'consts/building';

const DEFAULT_SCENE_MAP = {
  [ROUTE_MAP.overview.id]: {
    groupId: OVERVIEW_GROUP_ID,
    sceneId: OVERVIEW_SCENE_ID,
  },
};

export const useInitPage = (pageProps) => {
  const dispatch = useDispatch();
  const modifiedProps = useMemo(() => getMapSlug(pageProps), [pageProps]);

  const { tourId, groupId, sceneId, hotspotId, match } = modifiedProps;

  // Check if accessing /tong-quan directly
  const isOverviewRoute =
    match?.path?.includes(`/${ROUTE_MAP.overview.id}`) ||
    match?.path?.includes('/tong-quan');
  const hasSlug = match?.params?.slug;

  // For /tong-quan without slug, use default scene
  useEffect(() => {

    // Detect which page is being accessed
    let pageKey = null;
    if (isOverviewRoute) pageKey = ROUTE_MAP.overview.id;
    else if (match?.path?.includes(ROUTE_MAP['can-ho-mau']?.id || 'can-ho-mau'))
      pageKey = ROUTE_MAP['can-ho-mau'].id;

    const defaultScene = pageKey ? DEFAULT_SCENE_MAP[pageKey] : null;
    // Fallback to SCENE_IDS.default
    const fallbackScene = SCENE_IDS.default;

    if (!hasSlug && (defaultScene || fallbackScene)) {
      const finalScene = defaultScene || fallbackScene;
      dispatch(
        updateWorldParams({
          tourId,
          groupId: finalScene.groupId,
          sceneId: finalScene.sceneId,
          hotspotId: undefined,
        })
      );
    } else {
      dispatch(
        updateWorldParams({
          tourId,
          groupId,
          sceneId,
          hotspotId,
        })
      );
    }
  }, [dispatch, sceneId, hotspotId, tourId, groupId, isOverviewRoute, hasSlug, match]);

  return { modifiedProps, tourId, groupId, sceneId, hotspotId };
};
